
const form = document.getElementById('staff-form');

prefillFields();

document.addEventListener('DOMContentLoaded', () => {
  setupQualLevelListeners();
  setupErrorClearingListeners();
  form.addEventListener('submit', handleFormSubmit);
});

/**
 * Escape HTML characters to prevent XSS.
 */
function escapeHTML(text = '') {
  return text.replace(/[&<>"']/g, match => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[match]));
}

/**
 * Read a query string parameter from the URL.
 */
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

/**
 * Prefill all known fields from query params.
 */
function prefillFields() {
  const mappings = [
    { param: 'name', id: 'namePrefill', isInput: false },
    { param: 'business', id: 'businessPrefill', isInput: false },
    { param: 'businessId', id: 'businessId', isInput: true }
  ];

  mappings.forEach(({ param, id, isInput }) => {
    const value = getQueryParam(param);
    const el = document.getElementById(id);
    if (value && el) {
      const decoded = decodeURIComponent(value);
      if (isInput) {
        el.value = decoded;
        el.readOnly = true;
      } else {
        el.innerText = decoded;
      }
    } else if (!(window.Shopify && window.Shopify.designMode)) {
      window.location.replace('/');
    }
  });
}

/**
 * Toggle visibility of alternate qualification field when "Other" is selected.
 */
function setupQualLevelListeners() {
  document.querySelectorAll('select[name*="[qualificationLevel]"]').forEach(select => {
    select.addEventListener('change', () => {
      const staffEntry = select.closest('.staff-entry');
      const altFieldWrapper = staffEntry.querySelector('.alt-qualification-field');
      if (select.value === 'Other (please specify)') {
        altFieldWrapper.style.display = 'block';
      } else {
        altFieldWrapper.style.display = 'none';
        const altInput = altFieldWrapper.querySelector('input');
        if (altInput) altInput.value = '';
      }
    });
  });
}

/**
 * Validate all staff entry blocks and highlight errors.
 */
function validateAllStaffEntries() {
  let valid = true;
  document.querySelectorAll('.staff-entry').forEach(entry => {
    entry.querySelectorAll('input[type="text"], input[type="email"]').forEach(input => {
      const errorEl = input.parentElement.querySelector('.error-msg');
      const isEmail = input.type === 'email';
      const isValidEmail = /^\S+@\S+\.\S+$/.test(input.value.trim());

      if (!input.value.trim()) {
        input.style.borderColor = '#ef3427';
        errorEl.textContent = 'This field is required';
        valid = false;
      } else if (isEmail && !isValidEmail) {
        input.style.borderColor = '#ef3427';
        errorEl.textContent = 'Enter a valid email';
        valid = false;
      } else {
        input.style.borderColor = '';
        errorEl.textContent = '';
      }
    });

    entry.querySelectorAll('select').forEach(select => {
      const errorEl = select.closest('.field').querySelector('.error-msg');
      if (!select.value) {
        select.style.borderColor = '#ef3427';
        errorEl.textContent = 'Please select an option';
        valid = false;
      } else {
        select.style.borderColor = '';
        errorEl.textContent = '';
      }
    });

    entry.querySelectorAll('input[type="file"][required]').forEach(fileInput => {
      const fileError = fileInput.closest('.field').querySelector('.error-msg');
      if (!fileInput.files.length) {
        fileInput.style.borderColor = '#ef3427';
        fileError.textContent = 'Upload required';
        valid = false;
      } else {
        fileInput.style.borderColor = '';
        fileError.textContent = '';
      }
    });
  });

  return valid;
}

/**
 * Clone and append a new staff entry form block.
 */
function addStaffEntry() {
  const container = document.getElementById('staffEntriesContainer');
  const currentEntries = container.querySelectorAll('.staff-entry');
  if (currentEntries.length >= 25) return;

  const template = currentEntries[0];
  const newEntry = template.cloneNode(true);
  const newIndex = currentEntries.length;

  newEntry.querySelector('.staff-entry-title').textContent = `Staff Member ${newIndex + 1}`;

  newEntry.querySelectorAll('[name]').forEach(el => {
    const fieldMatch = el.name.match(/\[([^\]]+)\]$/);
    if (fieldMatch) {
      const fieldName = fieldMatch[1];
      el.name = `staff[${newIndex}][${fieldName}]`;
      if (el.id) el.id = `staff-${newIndex}-${fieldName}`;
    }

    const label = el.closest('.field')?.querySelector('label');
    if (label && el.id) label.setAttribute('for', el.id);

    el.value = '';
    el.style.borderColor = '';
  });

  newEntry.querySelectorAll('.error-msg').forEach(err => err.textContent = '');

  const removeBtn = newEntry.querySelector('.remove-staff-entry');
  removeBtn.style.display = 'inline-block';
  removeBtn.onclick = () => {
    newEntry.remove();
    updateStaffEntryTitles();
  };

  container.appendChild(newEntry);
  setupQualLevelListeners();
  setupErrorClearingListeners();
  updateAddButtonState();
}

/**
 * Re-index all staff entries after removal or reordering.
 */
function updateStaffEntryTitles() {
  document.querySelectorAll('.staff-entry').forEach((entry, i) => {
    entry.querySelector('.staff-entry-title').textContent = `Staff Member ${i + 1}`;

    entry.querySelectorAll('select, input[type="file"], input[type="text"], input[type="email"]').forEach(el => {
      const fieldMatch = el.name.match(/\[([^\]]+)\]$/);
      if (fieldMatch) {
        const fieldName = fieldMatch[1];
        el.name = `staff[${i}][${fieldName}]`;
      }
    });

    const removeBtn = entry.querySelector('.remove-staff-entry');
    removeBtn.style.display = i === 0 ? 'none' : 'inline-block';
  });

  updateAddButtonState();
}

/**
 * Enable or disable the "Add Staff Member" button based on max limit.
 */
function updateAddButtonState() {
  const addBtn = document.getElementById('addStaffBtn');
  const entries = document.querySelectorAll('.staff-entry');
  addBtn.disabled = entries.length >= 25;
}

/**
 * Clear error styles/messages on user input/change.
 */
function setupErrorClearingListeners() {
  form.querySelectorAll('input[type="text"], input[type="email"]').forEach(input => {
    input.addEventListener('input', () => {
      input.style.borderColor = '';
      const errorEl = input.parentElement.querySelector('.error-msg');
      if (errorEl) errorEl.textContent = '';
    });
  });

  form.querySelectorAll('select').forEach(select => {
    select.addEventListener('change', () => {
      select.style.borderColor = '';
      const errorEl = select.closest('.field').querySelector('.error-msg');
      if (errorEl) errorEl.textContent = '';
    });
  });

  form.querySelectorAll('input[type="file"]').forEach(fileInput => {
    fileInput.addEventListener('change', () => {
      fileInput.style.borderColor = '';
      const errorEl = fileInput.closest('.field').querySelector('.error-msg');
      if (errorEl) errorEl.textContent = '';
    });
  });
}

/**
 * Handle form submit: validate, sanitize, send data, show thank you message.
 */
function handleFormSubmit(event) {
  event.preventDefault();

  const submitBtn = document.querySelector('#staff-form-submit');
  const formContainer = document.querySelector('.pro-form');

  if (!validateAllStaffEntries()) {
    window.scrollTo({ top: 460, behavior: 'smooth' });
    submitBtn.disabled = false;
    submitBtn.classList.remove('loading');
    return;
  }

  submitBtn.classList.add('loading');
  submitBtn.disabled = true;

  const formData = new FormData(form);

  document.querySelectorAll('.staff-entry').forEach((entry, index) => {
    const qualSelect = entry.querySelector(`select[name="staff[${index}][qualificationLevel]"]`);
    const altInput = entry.querySelector(`input[name="staff[${index}][altQualification]"]`);

    if (
      qualSelect &&
      altInput &&
      qualSelect.value === 'Other (please specify)' &&
      altInput.value.trim()
    ) {
      const customValue = altInput.value.trim();
      formData.set(`staff[${index}][qualificationLevel]`, customValue);
    }
  });

  document.querySelectorAll('input[name*="[altQualification]"]').forEach(input => {
    formData.delete(input.name);
  });

  [...form.elements].forEach(el => {
    if (!el.name || el.type === 'submit') return;
    const value = el.value?.trim();
    if (!value || value === '---') {
      formData.delete(el.name);
    }
  });

  // Submit data via fetch
  fetch('https://hook.eu2.make.com/8kvbfq6sbdqpbxgl5bldpbshh5p4xv9r', {
    method: 'POST',
    body: formData,
    cache: 'no-cache'
  })
    .then(res => res.text())
    .then(() => {
      submitBtn.classList.remove('loading');
      formContainer.style.display = 'none';
      document.getElementById('thankYouPage').style.display = 'flex';
      window.scrollTo({ top: 0, behavior: 'smooth' });
      form.reset();
    })
    .catch(error => {
      alert('An error occurred: ' + error.message);
      submitBtn.disabled = false;
      submitBtn.classList.remove('loading');
    });
}